import React from 'react'

// History

import {
    useHistory
} from "react-router-dom"

// Amplify 

import { 
    API
} from 'aws-amplify'

// Styles

import { 
    Div,
    BlueTint 
} from '../../Styles/BaseStyles'

import { 
    NavDiv, 
    NavDivContainer,
    LeftNavList, 
    MidNavList, 
    RightNavList, 
    NavListItem,
    TitleIconButton, 
    TitleButton, 
    HoverTitleButton,
    SaveButton, 
    EditButton,
    ExitButton,
    BackButton,
    AddButton
} from '../../Styles/Components/NavBarStyles'

// Enums

import * as AppViewerEnums from '../../Constants/AppViewerEnums'

// Components

import CredentialActionsUtil from './CredentialActionsUtil'
import DropdownButton from './DropdownButton'

// import dispatch and selector

import { useSelector, useDispatch } from "react-redux"

import { toggleLock, showAlert, appViewerError, appViewerInfo, reset as appViewerSliceReset, setLock, setMode } from '../../Redux/Slices/AppViewerSlice'
import { resetHubPage } from '../../Redux/Slices/HubSlice'

import { generateDisplayName } from '../../Utilities/HubTools'
import { getApplicationDefaultValues } from '../../Utilities/ApplicationTools'

import { 
    useFormContext
} from "react-hook-form"

import * as mutations from '../../graphql/mutations'

function NavBar(props) {
    var leftNav
    var midNav
    var rightNav

    let history = useHistory()

    var mode

    const dispatch = useDispatch()

    const locked = useSelector(state => state.appViewer.locked)

    const applicationID = useSelector(state => state.user.applicationID)

    const appViewerMode = useSelector(state => state.appViewer.mode)
    const currentApplicationID = useSelector(state => state.appViewer.currentApplicationID)

    const hubPage = useSelector(state => state.hub.hubPage)

    const methods = useFormContext()

    var divContainerStyle = {}

    function mainPage(e){
        history.push('/')
    }

    async function saveApplication(data,e){
        try{
            var application_data = {...data}
            const defaults = getApplicationDefaultValues(hubPage)

            for(var key in defaults){
                if(!(key in application_data)){
                    application_data[key] = defaults[key]
                }
            }

            application_data['applications_id'] = applicationID

            const processed_data = processData(application_data)
    
            if(appViewerMode === 'create'){
                switch(hubPage){
                    case 'resume':
                        await API.graphql({ query: mutations.createResume, variables: {input: processed_data}})
                        break
                    default:
                        break
                }
            }
    
            if(appViewerMode === 'update'){
                switch(hubPage){
                    case 'resume':
                        processed_data['id'] = currentApplicationID
                        await API.graphql({ query: mutations.updateResume, variables: {input: processed_data}})
                        break
                    default:
                        break
                }
            }
    
            dispatch(appViewerInfo({infoPhrase: 'Application Saved'}))
            dispatch(toggleLock())
        }
        catch (error) {
            dispatch(appViewerError({errorPhrase: 'Error During Save: ' + error.message}))
        }
    }

    function processData(data){//todo at a future point/release
        var processed_data = {...data}
        return processed_data
    }

    function editApplication(e){
        dispatch(toggleLock())
    }

    function exitSettings(e){
        history.push('/hub')
    }

    function exitAppViewer(e){
        if(!locked){
            dispatch(showAlert({alertType: 'exit'}))
        }
        else{
            dispatch(appViewerSliceReset())
            history.push('/hub')
        }
    }

    function backToAppTypes(e){
        dispatch(resetHubPage())
    }

    function addApplication(){
        const path = '/appviewer/'+hubPage
        dispatch(setLock({locked: false}))
        dispatch(setMode({mode: 'create'}))
        history.push(path)
    }

    function setMainNav(){
        leftNav = (
            <>
                <NavListItem>
                    <TitleIconButton />
                </NavListItem>
                <NavListItem>
                    <HoverTitleButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</HoverTitleButton>
                </NavListItem>
            </> 
        )
        rightNav = <CredentialActionsUtil />
    }

    function setAppViewerNav(){
        const { handleSubmit } = methods
        
        if(locked){
            mode = AppViewerEnums.MODES.VIEWING
        }
        else{
            mode = AppViewerEnums.MODES.EDITING
        }

        var modeButton

        if(mode === AppViewerEnums.MODES.EDITING){
            modeButton = <SaveButton onClick={handleSubmit(saveApplication)} />
        }

        if(mode === AppViewerEnums.MODES.VIEWING){
            modeButton = <EditButton onClick={editApplication} /> 
        }

        leftNav = (
            <NavListItem>
                <ExitButton onClick={exitAppViewer} />
            </NavListItem>
        )

        rightNav = (
            <NavListItem>
                {modeButton}
            </NavListItem>
        )
        
        divContainerStyle = {'maxWidth': '120rem'}
    }

    function setHubNav(){
        if(hubPage === ''){
            leftNav = (
                <NavListItem>
                    <TitleButton style={{'cursor': 'default'}}><BlueTint>Application Hub</BlueTint></TitleButton>
                </NavListItem>
            )
        }
        else{
            leftNav = (
                <NavListItem>
                    <BackButton onClick={backToAppTypes} />
                </NavListItem>
            )
            midNav = (
                <NavListItem>
                    <TitleButton style={{'cursor': 'default'}}>{generateDisplayName(hubPage)+' Hub'}</TitleButton>
                </NavListItem>
            )
        }
        rightNav = (
            <>
                {hubPage !== '' ? 
                    <NavListItem>
                        <AddButton onClick={addApplication} />
                    </NavListItem> :
                    <NavListItem>
                        <DropdownButton ddButtonName="settings"/>
                    </NavListItem>
                }
            </>
        )
    }

    function setSettingsNav(){
        leftNav = (
            <NavListItem>
                <BackButton onClick={exitSettings} />
            </NavListItem>
        )
        midNav = (
            <NavListItem>
                <TitleButton style={{'cursor': 'default'}}><BlueTint>Settings</BlueTint></TitleButton>
            </NavListItem>
        )
        divContainerStyle = {'maxWidth': '100rem'}
    }

    switch(props.page){
        case "AppViewer":
            setAppViewerNav()
            break
        case "Hub":
            setHubNav()
            break
        case "Main":
            setMainNav()
            break
        case "Settings":
            setSettingsNav()
            break
        default:
            break
    }
    
    return (
        <NavDiv id="nav-bar">
            <NavDivContainer style={divContainerStyle}>
                <LeftNavList id='left-nav'>
                    {leftNav}
                </LeftNavList>
                <Div id="mid-nav">
                    <MidNavList>
                        {midNav}
                    </MidNavList>
                </Div>
                <RightNavList idd='right-nav'>
                    {rightNav}
                </RightNavList>
            </NavDivContainer>
        </NavDiv>
    )
}

export default NavBar
